import { Box, Button, Typography } from '@mui/material'

import { ContactCtaButton } from './ContactCtaButton'

const promotionalTextStyles = {
  fontSize: '18px',
  fontWeight: 600,
  color: '#1D1A33',
  textAlign: 'center' as const,
  mb: 2,
  lineHeight: '150%',
  letterSpacing: '0.15px',
}

const feedbackButtonStyles = {
  borderRadius: '8px',
  py: 1.5,
  lineHeight: '150%',
  letterSpacing: '0.15px',
  fontWeight: 600,
  fontSize: '13.33px',
  textTransform: 'none' as const,
  backgroundColor: 'white',
  border: '2px solid #7B2A8D',
  backgroundImage: 'linear-gradient(135deg, #471D7C 0%, #C6007E 100%)',
  backgroundClip: 'text',
  color: 'transparent',
  '&:hover': {
    backgroundColor: '#FCF0F9',
    border: '2px solid #7B2A8D',
    backgroundImage: 'linear-gradient(135deg, #471D7C 0%, #C6007E 100%)',
    backgroundClip: 'text',
    color: 'transparent',
  },
}

interface DeliveryFeedbackActionsProps {
  talkToAnExpertUrl: string
}

export const DeliveryFeedbackActions = ({ talkToAnExpertUrl }: DeliveryFeedbackActionsProps) => {
  const handleFeedbackClick = () => {
    window.open(talkToAnExpertUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <Box sx={{ mt: '0.5px' }}>
      <Typography sx={promotionalTextStyles}>
        You&apos;ve seen how easy delivery can be with FirstPoint.
      </Typography>
      <Button fullWidth variant='outlined' sx={feedbackButtonStyles} onClick={handleFeedbackClick}>
        Give Feedback
      </Button>
      <ContactCtaButton talkToAnExpertUrl={talkToAnExpertUrl} />
    </Box>
  )
}
